import React from 'react';
import { Box, Button, FormControlLabel, Switch, Typography } from '@mui/material';
import { selectedElement, updateContentElementById } from 'features/document/documentSlice';
import { isContractInfoTableElement } from 'utils/typeGuards';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import EditIcon from '@mui/icons-material/Edit';
import {
  hideRowByCellIds,
  showRowByCellIds,
} from 'pages/DocumentBuilder/components/ContentSection/components/ElementSection/components/ContractInfoTable/ContractInfoTable.utils';
import { openInNewTab } from 'utils/openInNewTab';
import { selectContract } from 'features/salesforce/salesforceSlice';

interface ContractInfoTableSidebarProps {
  currentElement: selectedElement;
}

export default function ContractInfoSidebar({ currentElement }: ContractInfoTableSidebarProps) {
  const tableElement = currentElement.data;
  if (!isContractInfoTableElement(tableElement)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const salesforceBaseUrl = useAppSelector(state => state.auth.salesforceBaseUrl);
  const activeContract = useAppSelector(selectContract);

  const tableContent = tableElement.content;
  const { hideDescriptionRow, hideSpecialTermsRow } = tableContent;

  const handleOnChangeHideDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    let newTable;

    if (!checked) {
      newTable = hideRowByCellIds(['cell-15', 'cell-16'], tableContent);
    } else {
      newTable = showRowByCellIds(['cell-15', 'cell-16'], tableContent);
    }

    dispatch(
      updateContentElementById({
        content: {
          ...newTable,
          hideDescriptionRow: !checked,
        },
        style: {},
      })
    );
  };

  const handleOnChangeHideSpecialTerms = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    let newTable;

    if (!checked) {
      newTable = hideRowByCellIds(['cell-11', 'cell-12'], tableContent);
    } else {
      newTable = showRowByCellIds(['cell-11', 'cell-12'], tableContent);
    }

    dispatch(
      updateContentElementById({
        content: {
          ...newTable,
          hideSpecialTermsRow: !checked,
        },
        style: {},
      })
    );
  };

  const handleClickEditContract = () => {
    if (salesforceBaseUrl && activeContract.Id) {
      openInNewTab(`${salesforceBaseUrl}/lightning/r/Contract/${activeContract.Id}/edit? `);
    }
  };

  return (
    <Box alignItems={'flex-start'} display={'flex'} flexDirection={'column'}>
      <Typography fontSize={'16px'} fontWeight={500} marginBottom={'32px'}>
        Contract Information Block
      </Typography>
      <Box display={'flex'} flexDirection={'column'} gap={'24px'} width={'100%'}>
        <Button
          startIcon={<EditIcon />}
          sx={{ textTransform: 'capitalize' }}
          variant='outlined'
          onClick={handleClickEditContract}
        >
          Edit Contract In CRM
        </Button>
      </Box>
      <Typography fontSize={'14px'} fontWeight={500} marginTop={'32px'}>
        Hide & Show Data
      </Typography>
      <Box display={'flex'} flexDirection={'column'} gap={'8px'} marginTop={'16px'}>
        <FormControlLabel
          control={<Switch checked={!hideDescriptionRow} color='secondary' onChange={handleOnChangeHideDescription} />}
          label='Description'
        />
        <FormControlLabel
          control={
            <Switch checked={!hideSpecialTermsRow} color='secondary' onChange={handleOnChangeHideSpecialTerms} />
          }
          label='Special Terms'
        />
      </Box>
    </Box>
  );
}
